import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, Crud, CrudService, CustomHttp } from '../../../core';
import { Atividade } from '../atividade';

@Injectable({
    providedIn: 'root'
})
export class AtividadeCrudHttpService implements Crud<Atividade> {
    resource = 'atividade';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todas as atividades cadastradas */
    search(): Observable<Atividade[]> {
        return this.crudService.search<Atividade>(this.resource);
    }

    /** Procura uma única atividade através do seu ID */
    find(id: number): Observable<Atividade> {
        return this.crudService.find<Atividade>(this.resource, id);
    }

    /** Carrega uma única atividade através do seu ID */
    load(id: number): Observable<Atividade> {
        return this.crudService.load<Atividade>(this.resource, id);
    }

    /** Insere uma nova atividade */
    insert(entity: Atividade): Observable<Atividade> {
        return this.crudService.insert<Atividade>(this.resource, entity);
    }

    /** Altera uma atividade existente */
    update(entity: Atividade): Observable<Atividade> {
        return this.crudService.update<Atividade>(this.resource, entity);
    }

    /** Exclui uma atividade através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
